// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal_scrollable_footer-module__container--2QwyK{width:100%;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;min-height:64px;padding:16px 32px;border-top:1px solid #e7ebef;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;margin-top:auto}@media screen and (max-width: 48em){.modal_scrollable_footer-module__container--2QwyK{padding:16px 24px}}\n", ""]);
// Exports
exports.locals = {
	"container": "modal_scrollable_footer-module__container--2QwyK"
};
module.exports = exports;
